export default __webpack_public_path__ + "img/aefc7deef0b01305bdb2134e16a2b91a.png";